<template lang="html">
  <div class="" />
</template>

<script>
import moment from 'moment'
export default {
  props: {
    formula: String,
    cData: Object
    // value: [String, Number]
  },
  data () {
    return {
      internalChange: false,
      moment: moment
    }
  },
  watch: {
    formula () {
      this.$emit('input', this.calculate(this.formula))
    },
    cData: {
      handler: function () {
        if (this.internalChange) return
        this.$emit('input', this.calculate(this.formula))
      },
      deep: true
    }
  },
  mounted () {
    this.$emit('input', this.calculate(this.formula))
  },
  methods: {
    calculate (str) {
      var $ = this // eslint-disable-line no-unused-vars
      if (!str) return ''
      this.internalChange = true

      this.$nextTick(() => {
        this.internalChange = false
      })
      return eval(str) // eslint-disable-line no-eval
    }
  }
}
</script>

<style lang="css" scoped>
</style>
